import { all, call } from 'redux-saga/effects';
import { sagas as attach } from './attachModule';
import { sagas as detach } from './detachModule';
import { sagas as resize } from './resizeModule';

export default function* clusterSaga() {
	yield all([call(attach), call(detach), call(resize)]);
}
